export default "__VITE_ASSET__BSsaAm$P__"